import { render } from "./DeliveryHistoryItem.vue?vue&type=template&id=199ca1c4&scoped=true"
import script from "./DeliveryHistoryItem.vue?vue&type=script&lang=js"
export * from "./DeliveryHistoryItem.vue?vue&type=script&lang=js"

import "./DeliveryHistoryItem.vue?vue&type=style&index=0&id=199ca1c4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199ca1c4"]])

export default __exports__